import styled from 'styled-components'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'

/** The warm flat copy control from the create-trip success screen: the Button's tonal variant, kept compact. */
export const CopyControl = styled(Button).attrs({ variant: 'tonal' as const })`
	min-width: 72px;
	flex-shrink: 0;
	padding: 10px 16px;
	font-size: ${fontSizes.base};
`
